import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Delay showing the banner
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4"
          data-testid="cookie-consent"
        >
          <div className="container mx-auto max-w-4xl">
            <div className="bg-midnight-navy rounded-2xl shadow-strong p-6 border border-white/10">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
                <div className="p-3 bg-champagne-gold/20 rounded-xl flex-shrink-0">
                  <Cookie className="w-6 h-6 text-champagne-gold" />
                </div>
                
                <div className="flex-1">
                  <h3 className="font-heading font-semibold text-white mb-1">
                    We use cookies
                  </h3>
                  <p className="text-paris-stone/80 text-sm">
                    We use cookies to enhance your experience on our website. By continuing to browse, 
                    you agree to our use of cookies.{" "}
                    <Link to="/privacy" className="text-champagne-gold hover:underline">
                      Learn more
                    </Link>
                  </p>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0 w-full md:w-auto">
                  <Button
                    variant="outline"
                    onClick={handleDecline}
                    className="flex-1 md:flex-none bg-transparent border-white/20 text-white hover:bg-white/10 rounded-full"
                  >
                    Decline
                  </Button>
                  <Button
                    onClick={handleAccept}
                    className="flex-1 md:flex-none bg-champagne-gold hover:bg-champagne-gold/90 text-midnight-navy font-semibold rounded-full"
                    data-testid="accept-cookies"
                  >
                    Accept All
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
